// extracted by mini-css-extract-plugin
export var inline = "_vd-0";